















import { Component, Mixins, Prop } from 'vue-property-decorator'
import { mapGetters } from 'vuex'
import BuilderDefaultContainer from '@/components/builder/BuilderDefaultContainer.vue'
import BuilderDevice from '@/components/builder/BuilderDevice.vue'
import BuilderTooltip from '@/components/builder/BuilderTooltip.vue'
import BuilderButton from '@/components/builder/BuilderButton.vue'
import { ChatStubState } from '@/views/builder/chat/BuilderChat.vue'
import WithBuilderFakeChats from '@/mixins/WithBuilderFakeChats'
import BuilderDot from "@/components/builder/BuilderDot.vue"

@Component({
  components: {
    BuilderButton,
    BuilderTooltip,
    BuilderDevice,
    BuilderDefaultContainer,
    BuilderDot
  },
  computed: {
    ...mapGetters('builder', { appType: 'getAppType' }),
  },
})
export default class BuilderChatCapabilities extends Mixins(WithBuilderFakeChats) {
  @Prop({ required: true, type: Object }) readonly value!: ChatStubState

  @Prop({ required: true, type: Number }) readonly step!: number
  
  appType!: string
  
  async onNextClick(): Promise<void> {
    this.$emit('next')
  }

  async onStubStateReady(): Promise<void> {
    if (this.value.channels.length < 3) {
      this.$emit('back')
      return
    }

    this.$emit('input', { ...this.value, highlight: 'chats' })
  }
}
